import USER from '../ts/profileEditorEnum';

/**
 * @readonly
 * @enum {{Work: string, Home: string, Other: string}}
 */
const ADDRESS_TYPE = Object.freeze({ WORK: '4', HOME: '5', OTHER: '6' });

/**
 * @function getAddressType
 * @param {string} name
 * @returns {string}
 */
function getAddressType(name) {
	if (name === USER.ADDRESS_WORK) return ADDRESS_TYPE.WORK;
	if (name === USER.ADDRESS_HOME) return ADDRESS_TYPE.HOME;
	if (name === USER.ADDRESS_OTHER) return ADDRESS_TYPE.OTHER;

	return '';
}

export default getAddressType;
